import React from "react";
import { SortingIcon } from "../../assets";

const SortIcon = ({ onClick }) => {
  return <img className="sort-icon" src={SortingIcon} onClick={onClick} />;
};

export default SortIcon;
